import React,{useEffect,useState} from 'react';
import polaris2 from '../images/polaris2.jpg'
import mask from '../images/mask.jpeg'
import age_gender from '../images/me.jpg'
import polaris from '../images/polaris.png'

import '../styles/ProjectSlide.css'
import ProjectItem from './ProjectItem';
const ProjectSlide = ({trigger,current})=>{
    const [isTriggered,setIsTrigerred] = useState(false)
    const [isExtended,setExtended] = useState(false)
    const slideStageClass = isTriggered ? 'slide-part' :'initial'
    const sideStageClass = isTriggered ? 'side-pattern' : 'initial'
    const itemStageClass = isTriggered ? 'itemContainer':'initial'
 
    const extend = isExtended ? ' extended-slide-part':''
    useEffect(()=>{
        if(trigger){
           setIsTrigerred(true)
           
        }
        if(current===5){
            setExtended(true)
           }
       })
    return(
<>







<div className='projectSlide-flex'>


<div className='left-items-flex'>
<ProjectItem 
    title="Polaris v1"
    to='https://github.com/ChibaniMohamed/Polaris'
    description="Polaris v1 is a desktop app for face-recognition made using Python"
    img={polaris}
    direction="left"
    position='project-2'
    sideStageClass={sideStageClass} 
    itemStageClass={itemStageClass} 
    />
    
  
     <ProjectItem
     to='https://github.com/ChibaniMohamed/cnn_age_gender'
     title="Age and gender prediction"
     description="Age and gender classification is a dual-task of identifying the age and gender of a person from an image or video"
     img={age_gender}
     direction="right"
     position='project-3'
     sideStageClass={sideStageClass} 
    itemStageClass={itemStageClass} 
    />
    <span style={{position:'absolute',top:'60px'}} id='sixth-part'>

</span>
    
    </div>
    


  








<svg className={slideStageClass+extend} width="97" height="2599" viewBox="0 0 97 2599" fill="none" xmlns="http://www.w3.org/2000/svg">

<circle cx="18" cy="43" r="4.5" stroke="#0066FF"/>
<circle cx="80" cy="43" r="4.5" stroke="#0066FF"/>
<circle cx="35" cy="100" r="4.5" fill="#0066FF" stroke="#0066FF"/>
<circle cx="63" cy="100" r="4.5" fill="#0066FF" stroke="#0066FF"/>
<path d="M63 105V189.5" stroke="#0066FF"/>
<path d="M35 105V192.5" stroke="#0066FF"/>
<circle cx="24" cy="5" r="4.5" fill="#0066FF" stroke="#0066FF"/>
<circle cx="73" cy="5" r="4.5" fill="#0066FF" stroke="#0066FF"/>

<path d="M76 9L96.5 34V89.5L83 109V156L73.5 172" stroke="#0066FF"/>
<path d="M21.5 9L1 34V89.5L14.5 109V156L24 171" stroke="#0066FF"/>
<path d="M49.5 894.501L33.5 910.501L49.5 926.501L65.5 910.501L49.5 894.501Z" fill="#0066FF"/>
<path d="M49.5 1267L33.5 1283L49.5 1299L65.5 1283L49.5 1267Z" fill="#0066FF"/>
<path d="M49.5 2038L33.5 2054L49.5 2070L65.5 2054L49.5 2038Z" fill="#0066FF"/>
<path d="M49.5 2410L33.5 2426L49.5 2442L65.5 2426L49.5 2410Z" fill="#0066FF"/>
<path d="M49.5 894.501L33.5 910.501L49.5 926.501L65.5 910.501L49.5 894.501Z" stroke="#0066FF"/>
<path d="M49.5 1267L33.5 1283L49.5 1299L65.5 1283L49.5 1267Z" stroke="#0066FF"/>
<path d="M49.5 2038L33.5 2054L49.5 2070L65.5 2054L49.5 2038Z" stroke="#0066FF"/>
<path d="M49.5 2410L33.5 2426L49.5 2442L65.5 2426L49.5 2410Z" stroke="#0066FF"/>
<path d="M49.5 23V2594" stroke="#0066FF"/>
<path d="M18 47.5V64.5L23 75V169L35 189.5V820.5L43.5 831.5V894L27.5 911L43.5 927.5L44 1266.5L27.5 1283L44 1299.5V2037L28 2054L44 2070.5L44.5 2409.5L28 2426L44.5 2442.5C44.5 2442.5 44.5 2513.94 44.5 2552L44.5 2578C44.5 2592 34.5 2594.5 34.5 2594.5" stroke="#0066FF"/>
<path d="M80.5 47V64L75.5 74.5V168.5L63.5 189V678.5V820.5L55 831.5V871V894L71.5 911L55 927.5V1266.5L71.5 1284L55 1299.5V2037L71.5 2054L55 2070.5V2409.5L71 2426L55 2442.5C55 2442.5 55 2526.44 55 2558C55 2567.84 55 2575.15 55 2578C55 2592 65 2594.5 65 2594.5" stroke="#0066FF"/>
<path d="M55 927.605L59.4231 932L79.5 911" stroke="#0066FF"/>
<path d="M55 894.395L59.4231 890L79.5 911" stroke="#0066FF"/>
<path d="M75.0502 905.778L77.3385 904.02L83.9997 911.579" stroke="#0066FF"/>
<path d="M74.5 916.5L77.3385 918.559L83.9996 911" stroke="#0066FF"/>
<path d="M55 2070.6L59.4231 2075L79.5 2054" stroke="#0066FF"/>
<path d="M55 2037.4L59.4231 2033L79.5 2054" stroke="#0066FF"/>
<path d="M75.0502 2048.78L77.3385 2047.02L83.9997 2054.58" stroke="#0066FF"/>
<path d="M74.5 2059.5L77.3385 2061.56L83.9996 2054" stroke="#0066FF"/>
<path d="M44 1299L39.6424 1303L19.5655 1282" stroke="#0066FF"/>
<path d="M44 1266L39.5 1262L19.5655 1282" stroke="#0066FF"/>
<path d="M24.0153 1276.78L21.727 1275.02L15.0658 1282.58" stroke="#0066FF"/>
<path d="M24.5655 1287.5L21.727 1289.56L15.0658 1282" stroke="#0066FF"/>
<path d="M44.5 2442.5L39.6424 2446L19.5655 2425" stroke="#0066FF"/>
<path d="M44.5 2409.5L39.5 2405L19.5655 2425" stroke="#0066FF"/>
<path d="M24.0153 2419.78L21.727 2418.02L15.0658 2425.58" stroke="#0066FF"/>
<path d="M24.5655 2430.5L21.727 2432.56L15.0658 2425" stroke="#0066FF"/>
<path id='project-1' d="M39 910.607L49.6066 900L60.2132 910.607L49.6066 921.213L39 910.607Z" fill="black"/>
<path id='project-2' d="M39 1282.61L49.6066 1272L60.2132 1282.61L49.6066 1293.21L39 1282.61Z" fill="black"/>
<rect x="44" y="910.657" width="8" height="8" transform="rotate(-45 44 910.657)" fill="#0066FF"/>
<rect x="44" y="1282.66" width="8" height="8" transform="rotate(-45 44 1282.66)" fill="#0066FF"/>
<path id='project-3' d="M39 2053.8L49.8032 2043L61 2054.2L50.1968 2065L39 2053.8Z" fill="black"/>
<rect x="44" y="2054.12" width="8.65763" height="8.728" transform="rotate(-45 44 2054.12)" fill="#0066FF"/>
<path id='project-4' d="M39 2425.8L49.8032 2415L61 2426.2L50.1968 2437L39 2425.8Z" fill="black"/>
<rect x="44" y="2426.12" width="8.65763" height="8.728" transform="rotate(-45 44 2426.12)" fill="#0066FF"/>
<rect x="47.0625" y="2595.82" width="3.46" height="3.45936" transform="rotate(-45 47.0625 2595.82)" stroke="#0066FF"/>
<circle cx="33" cy="2595" r="2" fill="#0066FF"/>
<circle cx="66" cy="2595" r="2" fill="#0066FF"/>

</svg>

<div  className='right-items-flex'>





    
<ProjectItem
    title="Polaris V2"
    id='fifth-part'
    position='project-1'
    to='https://github.com/ChibaniMohamed/Polaris-2'
    description="Polaris v2 is a web-based face-recognition attendence system made using JavaScript"
    img={polaris2}
    direction="right"
    sideStageClass={sideStageClass} 
    itemStageClass={itemStageClass} 
    />
   
    <ProjectItem
    title="Covid-19 Face Mask Detection"
    
    position='project-4'
    to='https://github.com/ChibaniMohamed/facemask_detection'
    description="Face Mask Detection system based on computer vision and deep learning using OpenCV and Tensorflow/Keras "
    img={mask}
    direction="right"
    sideStageClass={sideStageClass} 
    itemStageClass={itemStageClass} 
    />
    


</div>
   
</div>



</>
    )
}
export default ProjectSlide;






